const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL || "https://aqgeoubahtnbzgfglgky.supabase.co";
const EVENTS_FUNCTION_URL =
  process.env.REACT_APP_EVENTS_FUNCTION_URL ||
  `${SUPABASE_URL}/functions/v1/calendar-events`;

export async function fetchEvents() {
  const response = await fetch(EVENTS_FUNCTION_URL);
  const body = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(body.error || "Events are temporarily unavailable.");
  }

  if (!Array.isArray(body.events)) {
    throw new Error("The event service returned an invalid response.");
  }

  return body.events;
}
